module.exports = __webpack_public_path__ + "img/TO.02f4076e.svg";